<div class="flex items-center gap-2">
    <!-- Label (optional) -->
    <span *ngIf="showLabel()" class="flex items-center text-sm font-medium whitespace-nowrap text-white">
        <i class="pi pi-database mr-1.5 text-white"></i>
        <span>{{ 'header.selection.label' | translate }}</span>
    </span>

    <!-- Tree Select -->
    <p-treeSelect 
        *ngIf="!isLoading()"
        [options]="treeNodes" 
        [(ngModel)]="selectedNode"
        [placeholder]="'header.selection.placeholder' | translate"
        [showClear]="false"
        [panelStyleClass]="'tree-select-panel'"
        [containerStyleClass]="containerStyleClass()"
        display="chip"
        size="small"
        selectionMode="single"
        appendTo="body"
        [filter]="true"
        [virtualScroll]="true"
        [virtualScrollItemSize]="35"
        [virtualScrollOptions]="{ scrollHeight: '400px' }"
        (onNodeSelect)="onNodeSelect($event)"
        (onNodeUnselect)="onNodeUnselect($event)">
        
        <!-- Custom value template for selected item -->
        <ng-template let-value pTemplate="value">
            <div class="flex items-center gap-1.5" *ngIf="value">
                <i class="pi pi-database text-xs text-white"></i>
                <span class="font-medium text-sm text-white">
                    {{ userAccessService.currentSelection().libraryName }}
                </span>
                <i class="pi pi-angle-right text-xs text-white" style="opacity: 0.6;"></i>
                <i class="pi pi-bookmark text-xs text-white"></i>
                <span class="font-medium text-sm text-white">
                    {{ userAccessService.currentSelection().className }}
                </span>
            </div>
        </ng-template>
        
        <!-- Custom empty message template -->
        <ng-template pTemplate="empty">
            <div class="flex flex-col items-center justify-center py-6 px-4">
                <img src="assets/images/not_found.svg" alt="No results" class="w-20 h-auto mb-3 opacity-60">
                <p class="text-gray-500 text-sm">{{ 'header.selection.no-results' | translate }}</p>
            </div>
        </ng-template>
    </p-treeSelect>

    <!-- Loading indicator -->
    <i *ngIf="isLoading()" class="pi pi-spinner pi-spin text-white"></i>
</div>
